// The shared Quantity Qualifier code list (DE 673) — used by every QTY01
// across transaction sets. Union of the 852's existing QTY01 codes, the
// 844's, and the 867's, per reference/session/844-product-transfer-account-
// adjustment-qualifiers-txt.md and
// reference/session/867-product-transfer-and-resale-report-qualifiers-txt.md.
// The home for this DE going forward: a future transaction set's QTY01
// should extend this list rather than defining its own.

import type {CodeListEntry} from './types';

export const QUANTITY_QUALIFIER_CODES: CodeListEntry[] = [
  {code: '48', label: 'Units on Hand (Inventory)'},
  {code: '49', label: 'Units Sold (Sales)'},
  {code: 'ON', label: 'Units on Order'},
  {code: 'X6', label: 'Units Received'},
  {code: '01', label: 'Discrete Quantity'},
  {code: '39', label: 'Shipped Quantity'},
  {code: 'D1', label: 'Billed'},
  {code: 'QA', label: 'Quantity Approved'},
  {code: '38', label: 'Original Quantity'},
  {code: '17', label: 'Quantity on Hand'},
  {code: '33', label: 'Quantity Available for Sale (stock quantity)'},
  {code: '63', label: 'On Order Quantity'},
  {code: '76', label: 'Returns'},
  {code: 'V3', label: 'Transfer Quantity'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
